import { render, staticRenderFns } from "./AnPlainData.vue?vue&type=template&id=036e8412&scoped=true&"
import script from "./AnPlainData.vue?vue&type=script&lang=js&"
export * from "./AnPlainData.vue?vue&type=script&lang=js&"
import style0 from "./AnPlainData.vue?vue&type=style&index=0&id=036e8412&lang=scss&scoped=true&"
import style1 from "./AnPlainData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036e8412",
  null
  
)

export default component.exports